// example: '2024-12-24T20:14:17.111Z'
export const ISO_FORMAT = "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'";

export const LOCAL_FORMAT = "yyyy-MM-dd'T'HH:mm:ssXXX";
